import type { ShopPdpBook } from '#lib/websites/shop/pages/ShopBookPdp/types.js';
import {
	GalleryMedia,
	type GalleryItem,
} from '$global/components/Lightbox/types';
import { getImageUrl } from '$global/utils/getImageUrl';

export const getGallery = (book: ShopPdpBook): GalleryItem[] => {
	const title = book?.title || '';

	const galleryImages = (book?.gallery || [])
		.map((image, index) => {
			const url = getImageUrl(image?.directus_files_id?.filename_disk);
			const width = image?.directus_files_id?.width || 0;
			const height = image?.directus_files_id?.height || 0;

			if (!url) {
				return null;
			}

			return {
				type: GalleryMedia.image,
				media: {
					url,
					width,
					height,
				},
				title: `${title} image #${index + 2}`,
			};
		})
		.filter(Boolean) as GalleryItem[];

	const featuredImageUrl = getImageUrl(book?.featured_image?.filename_disk);

	return [
		...(featuredImageUrl
			? [
					{
						type: GalleryMedia.image,
						media: {
							url: featuredImageUrl,
							width: book?.featured_image?.width || 0,
							height: book?.featured_image?.height || 0,
						} as GalleryItem['media'],
						title: `${title} image #1`,
					},
				]
			: []),
		...galleryImages,
	];
};
